import React, { useState, useEffect } from 'react';
import { Input, Button } from 'components/shared/FormComponent';
import { Table, Popconfirm, TableProps } from 'components/shared/AntComponent';
import { DeleteFilled, SearchOutlined } from 'components/shared/AntIcons';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getProjectDetails } from 'services/store/actions/masterDataAction';
import { EditIcon, EyeIcon } from 'assets/icons/CustomIcons';
import AddProjectModal from './modal/AddProjectModal';
import { useNavigate } from 'react-router-dom';
import { Empty } from 'antd';

interface DataType {
    key: number;
    sno: number;
    Mdquestions_name: string;
    answer: string;
    level_of_difficulty: string;
    created_on: string;
}

const ProjectMaster: React.FC = () => {
    const { projectInfo, loading2 } = useSelector((state: any) => state.master);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(1);
    const data = !loading2 ? projectInfo?.ProjectDetail : [];
    const totalRecords = !loading2 ? projectInfo?.DataFinder?.totalrecords : 0;
    const [openModal, setOpenModal] = useState(false);
    const [rowData, setRowData]: any = useState(null);
    const customLocale = {
        emptyText: <Empty className="p-2" description="No Batch Details Available" />, 
    };
    const prjOptions = !loading2
        ? projectInfo?.ProjectDetail?.map((item: any) => {
            return {
                label: item.project_name,
                value: item.id?.toString(),
            };
        }) || []
        : [];
    prjOptions.push({ label: 'All', value: '0' });

    function getBatchData(page: number, size: number, search: string) {
        const inputJson = {
            UserInput: {
                project_id: 0,
            },
            DataFinder: {
                pagesize: size,
                currentpage: page,
                sortbycolumn: '',
                sortby: 'desc',
                searchdata: search,
            },
        };
        dispatch(getProjectDetails(inputJson) as any);
    }

    useEffect(() => {
        getBatchData(pageIndex, pageSize, searchValue);
    }, []);

    const handleSearch = (e: any) => {
        if (e.key === 'Enter') {
            setSearchValue(e.target.value);
            setPageIndex(1);
            getBatchData(1, pageSize, e.target.value);
        }
    };
    const resetSearch = (e: any) => {
        if (e.key === 'Backspace' && !e.target.value) {
            setSearchValue(e.target.value);
            setPageIndex(1);
            getBatchData(1, pageSize, e.target.value);
        }
    };
    const columns: TableProps<DataType>['columns'] = [
        {
            title: 'S.No',
            dataIndex: 'sno',
            key: 'sno',
            render: (id: any, record: any, index: any) => {
                if (pageIndex === 1) {
                    return index + 1;
                } else {
                    return (pageIndex - 1) * pageSize + (index + 1);
                }
            },
        },
        {
            title: 'Project No',
            dataIndex: 'projectno',
            key: 'projectno',
        },
        {
            title: 'Project Name',
            dataIndex: 'project_name',
            key: 'project_name',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Project Start Date',
            dataIndex: 'project_st_date',
            key: 'project_st_date',
            render: (project_st_date: any) => {
                const originalDate = new Date(project_st_date) || null;
                return data ? originalDate?.toLocaleString() : null;
            },
        },
        {
            title: 'Project End Date',
            dataIndex: 'project_en_date',
            key: 'project_en_date',
            render: (project_en_date: any) => {
                const originalDate = new Date(project_en_date) || null;
                return data ? originalDate?.toLocaleString() : null;
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status: any) => {
                return <div>{status}</div>;
            },
        },
        {
            title: 'Action',
            dataIndex: 'actions',
            key: 'actions',
            render: (_: any, record: any) => {
                return (
                    <div className="d-flex w-100">
                        <div className="pointer my-auto pb-3" onClick={() => editQuestion(record)}>
                            <EditIcon size={34} />
                        </div>
                        <div className="text-warning pointer eye-icon me-2 my-auto" onClick={() => viewDetails(record)}>
                            <EyeIcon size={20} />
                        </div>
                        <div className="my-auto delete-icon">
                            <Popconfirm title="Delete Question" description="Are you sure to delete this question?" onConfirm={() => deleteQuestion(record)} okText="Yes" cancelText="No">
                                <DeleteFilled className="text-danger pointer del-icon" />
                            </Popconfirm>
                        </div>
                    </div>
                );
            },
        },
    ];

    const editQuestion = (val: any) => {
        // setRowData(val);
        // setOpenModal(true);
        navigate('/project/add-project', { state: { id: val?.id, data: val, type: '2' } });
    };
    const viewDetails = (val: any) => {
        navigate('/project/view-details', { state: { id: '3', data: val, option: prjOptions, batchid: val?.id,batchUrl:'project' } });
    };
    const deleteQuestion = (val: any) => { };

    const paginationConfig: TableProps<DataType>['pagination'] = {
        position: ['bottomRight'],
        current: pageIndex,
        pageSize: pageSize,
        total: totalRecords,
        onChange: (page: number, pageSize: number) => {
            setPageIndex(page);
            setPageSize(pageSize);
            getBatchData(page, pageSize, searchValue);
        },
        itemRender: (current: any, type: string, originalElement: any) => {
            if (type === 'prev') {
                return <Button className="prev-btn">Previous</Button>;
            }
            if (type === 'next') {
                return <Button className="next-btn">Next</Button>;
            }
            return originalElement;
        },
    };
    const showModal = () => {
        // setOpenModal(true);
        // setRowData(null);
        navigate('/project/add-project', { state: { id: 0, data: null, type: '2' } });
    };
    const closeModal = () => {
        setOpenModal(false);
        setRowData(null);
    };

    const callbackFunc = () => {
        setPageIndex(1);
        getBatchData(1, pageSize, searchValue);
    };
    return (
        <div className="my-3">
            <div className="row m-0">
                <h5 className="col-md-3 text-start text-secondary my-auto fw-bold">Project</h5>
                <div className="col-md-8 pe-1 d-flex ms-auto">
                    <div className="col-md-4 text-start pe-0 ms-auto d-flex">
                        <Input
                            prefix={<SearchOutlined />}
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyDown={(e) => handleSearch(e)}
                            onKeyUp={(e) => resetSearch(e)}
                            placeholder="Search"
                        />
                        <Button type="primary" className="bg-primary ms-2" onClick={() => showModal()}>
                            Add
                        </Button>
                    </div>
                </div>
            </div>
            <div className="my-2 ms-2 me-1 custom-table">
                <Table columns={columns} dataSource={data} rowKey="id" loading={loading2} pagination={paginationConfig} locale={customLocale}/>
            </div>
            <AddProjectModal openModal={openModal} closeModal={closeModal} rowData={rowData} callbackFunc={callbackFunc} />
        </div>
    );
};

export default ProjectMaster;
